import React, { Component } from 'react';
import { connect } from 'react-redux'
import Table from 'react-bootstrap/Table';
import Navbar from './Navbar'
import { emptyItems } from './reducers/cartReducer'



class Confirm extends Component{
    constructor(props) {
        super(props)
        this.state = {          
            id: localStorage.getItem('idOrder'),    
            orderDetails: []   ,
            itemDetails:[]
            }
        }
    
    componentDidMount() {
        fetch('https://apps2.housing.k-state.edu/code/JPsatJardine/paymentShoppingCart.php?idOrder='+localStorage.getItem('idOrder'))
        .then((response) => {
          return response.json();
        }) .then(data => {
            this.setState({ orderDetails: data.orderDetails })
            this.setState({ itemDetails: data.itemDetails })
        });
        localStorage.clear();
    }

    refreshPage = () =>{
        this.props.emptyItems()
        this.props.history.push('/')

    }
       
    render(){
        return(
            <div>
            <Navbar isAuthed={false}/><div class="container"><br/>
            <button name="mainMenu" class="btn mainMenu " onClick={this.refreshPage}><b> {"<"} Main Menu</b> </button>
             {this.state.orderDetails.status != "Saved"?
             <div >
              <h5 class="alert alert-success"> You Order has been Confirmed. Thank you for your order</h5>
               <p><b>Order Confirmation Details</b></p>
               <span><strong>Confirmation# : {this.state.orderDetails.confirmationNumber} </strong></span><br/>
               <span><strong>Order# : {this.state.orderDetails.idOrder} </strong></span><br/>
               <span><strong>Ordered By :  {this.state.orderDetails.firstName} {this.state.orderDetails.lastName}</strong></span> <br/>
               {/* <span><strong>Ordered on : {this.state.orderDetails.dateOrdered} </strong></span><br/> */}
                <span><strong>Pickup Details: {this.state.orderDetails.deliveryType} at {this.state.orderDetails.pickupTime}  </strong></span><br/>
               <span><strong>Amount Paid: ${this.state.orderDetails.orderSubTotal} </strong></span><br/>
               {/* <span><strong>Payment Date: {this.state.orderDetails.paymentDate} </strong></span><br/> */}
                <span><strong>Items Ordered :</strong></span>
               <table>
                 <thead><tr>                   
                <th>Item</th>
                 <th>Selection</th>    
                 <th>Quantity</th>               
                 </tr></thead>
             {this.state.itemDetails.map((itemDetail)=>{ 
              return   <tbody>             
            
                 <tr>
                 <td>{itemDetail.title}</td>
                 <td>{itemDetail.toppings}</td>
                 <td>{itemDetail.quantity}</td></tr>
                
                 
            </tbody>              
            })}
            </table>
            </div>
            :
              <h5 class="materialert danger"> Sorry !! We cannot process your order right now.</h5>
              
                }
                </div>
            </div>
            
        )
    }


} 
const mapDispatchToProps = (dispatch)=>{
    return{
        emptyItems: (id)=>{dispatch(emptyItems())}, 
    }
}

export default connect(null,mapDispatchToProps)(Confirm)